module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.data.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    class: _vm.verifyFields(_vm.data, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "4.5%"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    class: _vm.verifyFieldsDoubleInput(_vm.data) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "32%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "number",
      "placeholder": _vm.data.label2
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model2, _vm.data.label2)
      }
    },
    model: {
      value: (_vm.data.model2),
      callback: function($$v) {
        _vm.$set(_vm.data, "model2", $$v)
      },
      expression: "data.model2"
    }
  })], 1), _vm._v(" "), (_vm.verifyFields(_vm.data, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.verifyFieldsDoubleInput(_vm.data)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.label2)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf7ebdee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DoubleInput.vue
// module id = 652
// module chunks = 1